<template>
  <form @submit.prevent="handleFilter" class="c-usersFilter mb-3">
    <b-card class="content-card">
      <b-row no-gutters class="text-right">
        <b-col lg="6" class="mb-3 d-pl-2">
          <b-form-group
            label="نیازمند تایید"
            label-for="stepSelect"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="md"
            class="mb-0"
          >
            <b-form-select
              v-model="selected"
              :options="options"
              class="mb-3"
              placeholder="انتخاب فیلتر"
              value-field="item"
              text-field="name"
              @change="handleSelectStep"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="mb-3 d-pr-2">
          <b-form-group
            label="جستجو کارت"
            label-for="searchCardNumber"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="md"
            class="mb-0"
          >
            <b-input-group>
              <b-form-input
                id="searchCardNumber"
                v-model="filterData.cardNumber"
                type="search"
                placeholder="جستجو کارت"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="mb-3 d-pl-2">
          <b-form-group
            label="جستجو شماره شبا"
            label-for="searchCardNumber"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="md"
            class="mb-0"
          >
            <b-input-group>
              <b-form-input
                id="searchCardNumber"
                v-model="filterData.IBan"
                type="search"
                placeholder="جستجو کارت"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="mb-3 d-pr-2">
          <b-form-group
            label="جستجو کاربر"
            label-for="searchUser"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="md"
            class="mb-0"
          >
            <b-input-group>
              <b-form-input
                id="searchUser"
                v-model="filterData.infoQuery"
                type="search"
                placeholder="جستجو کاربر"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="mb-3 d-pl-2">
          <b-form-group
            label="تعداد"
            label-for="perPage"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="md"
            class="mb-0"
          >
            <b-input-group>
              <b-form-input
                id="perPage"
                v-model.number="filterData.perPage"
                type="number"
                :placeholder="filterData.perPage + ''"
                min="1"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-button
            variant="primary"
            size="sm"
            class="p-2 pl-4 pr-4"
            type="submit"
            >جستجو
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </form>
</template>
<script>
import BaseSelect from "./Inputs/BaseSelect";

export default {
  components: {
    BaseSelect,
  },

  data() {
    return {
      options: [
        { item: null, name: "لطفا یک فیلتر انتخاب کنید" },
        { item: "Documents", name: "مدارک" },
      ],

      selected: null,

      filterData: {
        role: "",
        uncompletedStep: "",
        cardNumber: "",
        infoQuery: "",
        IBan: "",
        perPage: 25,
      },
    };
  },

  mounted() {
    if (this.$route.params.type == "document") {
      this.filterData.uncompletedStep = "Documents";
    } else if (this.$route.params.type === "personal-info") {
      this.filterData.uncompletedStep = "PersonalInfo";
    } else if (this.$route.params.type === "addresses") {
      this.filterData.uncompletedStep = "AddressPostalCode";
    } else {
      this.filterData.uncompletedStep = "";
    }
  },

  methods: {
    handleFilter() {
      Object.keys(this.filterData).map((key) => {
        // when deselect the select we got null and maybe it will make error in request, so should be ''
        if (this.filterData[key] === null) this.filterData[key] = "";
      });
      this.$emit("onFilterUsers", this.filterData);
    },

    handleSelectRole(value) {
      this.filterData.role = value;
    },

    handleSelectStep(value) {
      this.filterData.uncompletedStep = value;
    },
  },
};
</script>
<style lang="scss" scoped></style>
